import Icon from "@/components/Icon/index.vue";
import Hyperlink from "@/components/Hyperlink.vue";
import MainMenu from "./MainMenu.vue";
import mixins from "vue-typed-mixins";
import { featureToggleMixin, gtmMixin } from "@/mixins";
import menus from "@/menus";
export default mixins(featureToggleMixin, gtmMixin).extend({
    name: "Navbar",
    components: {
        Icon,
        Hyperlink,
        MainMenu,
    },
    props: {
        hasBanner: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        navItems: [
            { to: { name: "home" }, text: "Beranda" },
            // { name: "webinar", text: "Webinar" },
            // { name: "faq", text: "FAQ" },
            // { name: "contact", text: "Hubungi Kami" },
        ],
        showMenu: false,
    }),
    computed: {
        fixed() {
            return true;
        },
        menuItems() {
            return menus;
        },
    },
    methods: {
        toggleDropdown() {
            this.showMenu = !this.showMenu;
        },
        trackLogo() {
            this.gtmClickLink("menu_logo_pembelajaran");
        },
        onMenuClick(item) {
            this.showMenu = false;
            if (item.trackerValue) {
                this.gtmClickLink(item.trackerValue);
            }
        },
    },
});
